import React, { Component } from "react";
import { History } from "history";

import * as t from "@/lib/backend/manufacturing2.generated.types";
import { translate } from "@/modules/shared/IntlProviderWrapper";

import type { PersonStats } from "@/modules/dt/masterData/people/PeopleList";

import PeopleList from "@/modules/dt/masterData/people/PeopleList";

type Props = {
    history: History;
    handlePeopleClick: (person: t.IPersonData) => void;
    people: t.IPersonData[];
    people_stats?: Map<string, PersonStats>;
    selected: t.IPersonData | null;
    selectedPlant: string;
    selectedLineGroup: string;
};

type State = {
    name_filter: string;
};

class ShiftAssignmentsPeople extends Component<Props, State> {
    state: State = {
        name_filter: "",
    };

    handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const target = event.currentTarget;
        const value = target.value;
        const name = target.name;

        if (name === "name_filter") {
            this.setState({ name_filter: value });
        }
    };

    onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        event.nativeEvent.stopImmediatePropagation();

        if (event.key === "Enter") {
            event.preventDefault();
            return false;
        }
    };

    render() {
        return (
            <div id="shift-assignments-sidebar">
                <div className="vertical_tab">
                    <div className="sub-filter-bar sub-filter-bar2 nav-narrow">
                        <input
                            type="text"
                            className="form-control search_bar"
                            placeholder={translate("common.search", "Search")}
                            name="name_filter"
                            value={this.state.name_filter}
                            onChange={this.handleInputChange}
                            onKeyDown={this.onKeyDown}
                        />
                    </div>
                    <PeopleList
                        activeFilter={true}
                        narrow={true}
                        people={this.props.people}
                        people_stats={this.props.people_stats}
                        selected={this.props.selected}
                        filter={this.state.name_filter}
                        plantFilter={this.props.selectedPlant}
                        handlePeopleClick={this.props.handlePeopleClick}
                        line_group_uuid={this.props.selectedLineGroup}
                        showInactive={false}
                    />
                </div>
            </div>
        );
    }
}

export default ShiftAssignmentsPeople;
